module.exports = __webpack_public_path__ + "static/media/SOLUS_LR_MARKER_168.75deg.20cdcf8f.png";